export default __webpack_public_path__ + "static/media/WEB_APP_DEVELOPMENT.41da3103.jpg";